export abstract class MdsConfig {
  public static iconsDynamicImportPath: string | null;
}
